import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureAttribution } from "@/lib/attribution";
import { initPixel } from "@/lib/meta";

captureAttribution();
initPixel();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
